export default __webpack_public_path__ + "static/media/mg.a808f9bd.svg";